import { createAction, props } from '@ngrx/store';

import { Product } from '../../../shared/models/shared.model';
import { UpsertProductResponse } from '../../services/product-service.model';

export const loadData = createAction('[Product] Load Data');
export const clearProductState = createAction('[Product] Clear State');

export const setSelectedProductRequest = createAction(
  '[Product] Set Selected Product Request',
  props<{ id: number }>(),
);
export const setSelectedProductSuccess = createAction(
  '[Product] Set Selected Product Success',
  props<{ product: Product }>(),
);
export const setSelectedProductError = createAction(
  '[Product] Set Selected Product Error',
  props<{ error: Error }>(),
);

export const getCustomerProductsRequest = createAction('[Product] Get Customer Products Request');
export const getCustomerProductsSuccess = createAction(
  '[Product] Get Customer Products Success',
  props<{ customerProducts: Product[] }>(),
);
export const getProductsRequest = createAction(
  '[Product] Get Products Request',
  props<{ country?: string }>(),
);
export const getProductsSuccess = createAction(
  '[Product] Get Products Success',
  props<{ products: Product[] }>(),
);
export const getProductsError = createAction(
  '[Product] Get Products Error',
  props<{ error: Error }>(),
);

export const upsertProductRequest = createAction(
  '[Product] Upsert Product Request',
  props<{ request: Product }>(),
);
export const upsertProductSuccess = createAction(
  '[Product] Upsert Product Success',
  props<{ response: UpsertProductResponse }>(),
);
export const upsertCustomerProductSuccess = createAction(
  '[Product] Upsert Customer Product Success',
  props<{ response: UpsertProductResponse }>(),
);
export const upsertProductError = createAction(
  '[Product] Upsert Product Error',
  props<{ error: Error }>(),
);

export const deleteProductRequest = createAction(
  '[Product] Delete Product Request',
  props<{ product: Product }>(),
);
export const deleteProductWithConfirmation = createAction(
  '[Product] Confirm Delete Product',
  props<{ product: Product }>(),
);
export const deleteProductSuccess = createAction(
  '[Product] Delete Product Success',
  props<{ productId: number }>(),
);
export const deleteCustomerProductSuccess = createAction(
  '[Product] Delete Customer Product Success',
  props<{ productId: number }>(),
);

export const setSelectedCountry = createAction(
  '[Product] Set selected country',
  props<{ save: boolean; id: string }>(),
);
export const setSelectedCountrySuccess = createAction(
  '[Product] Set selected country success',
  props<{ id: string }>(),
);
export const loadSelectedCountry = createAction('[Product] Load selected country');
